/**
 * Profile-related constants used throughout the application
 */

// Profile types
export const PROFILE_TYPE = {
  PRIMARY: 'primary' as const,
  DEPENDENT: 'dependent' as const
};

export type ProfileType = 'primary' | 'dependent';

// Default profile - CRITICAL: MUST be 'u1'
export const DEFAULT_PROFILE_ID = 'u1';

// Profile IDs - use these constants everywhere
export const PROFILE_IDS = {
  USER_1: 'u1', 
  USER_2: 'u2'
};

// Profile names
export const PROFILE_NAMES = {
  USER_1: 'User 1',
  USER_2: 'User 2'
};

// Profile initials
export const PROFILE_INITIALS = {
  USER_1: 'U1',
  USER_2: 'U2'
};



// Profile labels
export const PROFILE_LABELS = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary'
};

// Storage keys - explicitly defined to avoid naming conflicts
export const PROFILE_CONSTANTS = {
  COOKIE_KEY: 'meduler_profile_id',
  STORAGE_KEY: 'currentProfileId',
  DEFAULT_ID: DEFAULT_PROFILE_ID
};
